import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b25541a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "morphing-logo",
  "aria-label": "MoTobi"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slots, (slot, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "morphing-logo__slot",
        style: _normalizeStyle({
        '--slot-duration': `${slot.duration}ms`,
        '--slot-delay': `${slot.delay}ms`,
        '--slot-width': _ctx.slotWidth(index),
      })
      }, [
        _createVNode(_Transition, {
          name: slot.slidesUp ? 'slot-up' : 'slot-down'
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("span", {
              key: slot.text,
              class: "morphing-logo__text"
            }, _toDisplayString(slot.text), 1))
          ]),
          _: 2
        }, 1032, ["name"])
      ], 4))
    }), 128))
  ]))
}